import { BrandedHeader as MxBrandedHeader } from '@repo/ui/BrandedHeader';
import { BrandedHeader as LegacyBrandedHeader } from '@repo/pdx-ui/BrandedHeader';
import { useIsMobile } from '@repo/dom/hooks/useMediaQuery';
import { useRetailerSettings } from '../../hooks/useRetailerSettings';

export const BrandedHeader = () => {
  const { features } = useRetailerSettings();
  const isMobile = useIsMobile();

  // A published brand-center header is the source of truth: the resolver only sets
  // `features.header` for a tenant that configured one, so its presence — not a query
  // flag — is what selects it. The legacy track `headerHtml` is the fallback for
  // tenants that have none, so a configured tenant never drops back to the seeded
  // demo markup that ships in the default experience.
  const header = features?.header;
  if (header) {
    return (
      <MxBrandedHeader
        header={header}
        device={isMobile ? 'mobile' : 'desktop'}
      />
    );
  }

  return (
    <LegacyBrandedHeader
      headerHtml={features?.headerHtml ?? null}
      isMobile={isMobile}
    />
  );
};
